import { FORM_FIELD_CLASS_NAME } from '../constants/styles';

/**
 * Builds the selector for every child of `parent` other than one that is the
 * first (or last) of its type and is not a form field root. Field roots are
 * divs, so `:first-of-type`/`:last-of-type` alone would count them among the
 * container's ordinary divs and move the edge onto a different div; field
 * roots are therefore matched by class and counted as a type of their own.
 */
export const childrenExceptTypeEdge = (
  edge: 'first' | 'last',
  parent = '&',
): string => {
  const otherDiv = `div:not(.${FORM_FIELD_CLASS_NAME})`;

  return [
    `${parent} > .${FORM_FIELD_CLASS_NAME}`,
    `${parent} > *:not(div):not(:${edge}-of-type)`,
    edge === 'first'
      ? `${parent} > ${otherDiv} ~ ${otherDiv}`
      : `${parent} > ${otherDiv}:has(~ ${otherDiv})`,
  ].join(', ');
};
